export default "__VITE_ASSET__kNrquQhw__"